import { Style } from '@solidjs/meta';

export function Veneer()
{
	return (
		<Style>{`@font-face{font-family:'Veneer Regular';font-style:normal;font-weight:400;font-display:auto;
src:url(https://www.brewlab.net.au/wp-content/uploads/2022/06/Veneer.eot);
src:url('https://www.brewlab.net.au/wp-content/uploads/2022/06/Veneer.eot?#iefix') 
format('embedded-opentype'),url(https://www.brewlab.net.au/wp-content/uploads/2022/06/Veneer.woff2) 
format('woff2'),url(https://www.brewlab.net.au/wp-content/uploads/2022/06/Veneer.woff) 
format('woff'),url(https://www.brewlab.net.au/wp-content/uploads/2022/06/Veneer.ttf) 
format('truetype'),url('https://www.brewlab.net.au/wp-content/uploads/2022/06/Veneer.svg#VeneerRegular') format('svg')}
`}</Style>
	);
}

